import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

export abstract class FormsAdapter {
  abstract postAdvancedForm(url: string, body: HttpParams): Observable<any>;
  abstract postAdvancedFormFile(url: string, body: FormData): Observable<string>;
}
